import {createURLQuery} from "../common/api/apiUtil";
import {DEFAULT_IMAGE_FORMAT, DEFAULT_IMAGE_QUALITY} from "../common/constant";

export const checkWebpFeature = () => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onerror = () => resolve(false);
        img.onload = () => resolve((img.width > 0) && (img.height > 0));
        img.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
    }).catch(() => false);
};

const contentfulImageApi = (() => {
    let webpSupport = null;
    if (webpSupport === null) {
        checkWebpFeature().then(result => {
            webpSupport = result;
        });
    }

    return {
        retrieveImage: (url, sizeOptions, formatOptions, manipulationOptions) => {
            let format = formatOptions?.format || DEFAULT_IMAGE_FORMAT;
            if(format === "webp" && webpSupport === false) {
                format = "jpg";
            }

            // REFERENCE https://www.contentful.com/developers/docs/references/images-api/#/reference
            let queryParams = {
                w: Math.round(sizeOptions?.width) || null,
                h: Math.round(sizeOptions?.height) || null,
                fit: sizeOptions?.fit || null,
                f: sizeOptions?.focus || null,
                fm: format,
                fl: formatOptions?.fl && ((format === "jpg" && formatOptions?.fl === "progressive") || (format === "png" && formatOptions?.fl === "png8")) ? formatOptions?.fl : null,
                q: manipulationOptions?.quality || DEFAULT_IMAGE_QUALITY,
                bg: manipulationOptions?.background || null
            };

            return url + createURLQuery(queryParams);
        }
    };
})();

export const retrieveContentfulImage = contentfulImageApi.retrieveImage;
